// extracted by mini-css-extract-plugin
var _1 = "ZGVHUd";
var _2 = "csUs9X";
var _3 = "zfjpmC";
var _4 = "lzrQwx";
var _5 = "ARwqiA";
var _6 = "IblxOv";
var _7 = "D3_Gkd";
var _8 = "MN6mW2";
var _9 = "XmrCXD";
var _a = "mjguM3";
export { _1 as "admin", _2 as "ease-transition", _3 as "gradient-titanic-80", _4 as "linear-transition-05", _5 as "modal", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white", _a as "user" }
